
import { motion } from 'framer-motion';

export default function Footer() {
  const footerLinks = {
    Platform: ['How It Works', 'Missions', 'Partners', 'About Us'],
    Shop: ['Amazon', 'Temu', 'TikTok Shop', 'Etsy', 'Shein'],
    Rewards: ['Merchandise', 'HMU Balance', 'Leaderboard', 'Badges'],
    Support: ['Help Center', 'Contact', 'FAQ', 'Terms'],
  };

  return (
    <footer className="bg-gradient-to-br from-teal-900 to-teal-800 relative overflow-hidden">
      {/* World Map Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 1200 600" fill="none">
          <path d="M200,100 L250,120 L280,90 L320,110 L350,95 L380,115 L420,100 L450,120 L480,105 L520,125 L550,110 L580,130 L620,115 L650,135 L680,120 L720,140 L750,125 L780,145 L820,130 L850,150 L880,135 L920,155 L950,140 L980,160 L1020,145" stroke="currentColor" strokeWidth="2" className="text-white"/>
          <path d="M150,200 L200,220 L230,190 L270,210 L300,195 L330,215 L370,200 L400,220 L430,205 L470,225 L500,210 L530,230 L570,215 L600,235 L630,220 L670,240 L700,225 L730,245 L770,230 L800,250 L830,235 L870,255 L900,240 L930,260 L970,245 L1000,265" stroke="currentColor" strokeWidth="2" className="text-white"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        {/* Upper Section */}
        <div className="grid lg:grid-cols-[30%_70%] gap-12 mb-12">
          {/* Left - Brand & Newsletter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-drop-fill text-3xl text-honey-500"></i>
              </div>
              <span className="text-2xl font-serif font-bold text-white">HoneyJar</span>
            </div>

            <h3 className="text-3xl font-serif text-white mb-6 leading-tight">
              Join 50,000+ Earners Today
            </h3>

            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-honey-500 transition-all"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-honey-500 rounded-xl hover:bg-honey-600 transition-all cursor-pointer">
                <i className="ri-notification-line text-xl text-white"></i>
              </button>
            </div>
          </motion.div>

          {/* Right - Navigation Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {Object.entries(footerLinks).map(([category, links], index) => (
              <motion.div
                key={category}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <h4 className="text-white font-bold text-sm mb-4">{category}</h4>
                <ul className="space-y-3">
                  {links.map((link) => (
                    <li key={link}>
                      <a
                        href="#"
                        className="text-white/80 text-sm hover:text-honey-400 transition-colors cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 mb-8"></div>

        {/* Lower Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Copyright */}
          <div className="text-white/70 text-sm">
            © 2025 Bingham ENT Global Empire. All rights reserved.
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {['ri-instagram-line', 'ri-twitter-x-line', 'ri-facebook-line', 'ri-linkedin-line'].map(
              (icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg text-white hover:bg-white hover:text-teal-900 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              )
            )}
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-4 text-white/70 text-sm">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <span>•</span>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">
              Terms
            </a>
            <span>•</span>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="nofollow noopener noreferrer" 
              className="hover:text-honey-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
